import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Restaurant from "../../../assets/icons/store.svg";
import Right from "../../../assets/icons/right-rounded.svg";
import Empty from "../../../assets/illustration/no-store.png";

import { RestaurantPropType } from "../../home/types";
import TopItemCard from "../component/TopItemCard";
import EmptyState from "../component/EmptyState";

import { IRootState } from "../../..";

const TopStore = () => {
  const navigate = useNavigate();
  const home = useSelector((state: IRootState) => state.home.value);

  const filteredData = home.home.popular.restaurants.filter(
    (restaurant) => restaurant.establishment_type === "STORE"
  );

  const onClick = (restaurant: RestaurantPropType) => {
    navigate(`/store/${restaurant.slug}`);
  };

  return (
    <div className="container mx-auto p-5 py-7  text-black">
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-2 items-center">
          <img src={Restaurant} alt="" className="w-6 h-6" />
          <div className="font-semibold text-base md:text-lg ">
            Top Stores In Your Area
          </div>
        </div>
        <div
          className="flex gap-2 items-center cursor-pointer"
          onClick={() => navigate("/store")}
        >
          <div className="font-normal text-base">View all</div>
          <img src={Right} alt="" />
        </div>
      </div>
      {filteredData.length === 0 ? (
        <EmptyState image={Empty} text="No Stores Found!" />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-3">
          {filteredData.slice(0, 4).map((restaurant) => (
            <TopItemCard
              key={restaurant.id}
              restaurant={restaurant}
              onClick={onClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TopStore;
